export default "__VITE_ASSET__B6S7A$ab__"